/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTextSpellcheck = createReactComponent("text-spellcheck", "IconTextSpellcheck", [
  ["path", { d: "M5 15v-7.5a3.5 3.5 0 0 1 7 0v7.5", key: "svg-0" }],
  ["path", { d: "M5 10h7", key: "svg-1" }],
  ["path", { d: "M10 18l3 3l7 -7", key: "svg-2" }]
]);

export { IconTextSpellcheck as default };
//# sourceMappingURL=IconTextSpellcheck.js.map
